import classNames from 'classnames';

import ActionIcon from 'components/BaseHelpers/ActionIcon';
import { IconType } from 'components/BaseHelpers/ActionIcon/ActionIcon';
import BaseCta, { BaseCtaProps } from 'components/BaseHelpers/BaseCta';
import Text from 'components/BaseHelpers/Text/Text';

import styles from './PillCTA.module.scss';

type OwnProps = {
  label?: string;
  variant?: 'default' | 'yellow';
  reversed?: boolean;
  children?: never;
  className?: string;
  keepBorderOnHover?: boolean;
};

export type PillCTAProps = BaseCtaProps & OwnProps;

const PillCTA = (props: PillCTAProps): JSX.Element | null => {
  const { label, tag, variant = 'default', reversed = false, className, keepBorderOnHover } = props;

  if (!label) return null;

  const ctaClass = classNames(className, styles.pill, styles[`theme--${variant}`], {
    [styles.reversed]: reversed,
    [styles['theme--keep-border']]: keepBorderOnHover,
  });

  if (tag === 'a') {
    const { target } = props;
    const { keepBorderOnHover, ...propsToPassOn } = props;

    let type: IconType = 'standard';
    if (props.href.includes('tel:')) {
      type = 'telephone';
    } else if (props.href.includes('mailto:')) {
      type = 'email';
    }

    return (
      <BaseCta {...propsToPassOn} className={ctaClass}>
        <span className={styles.label}>
          <Text field={label} />{' '}
          <ActionIcon
            className={styles.icon}
            aria-hidden
            external={target === '_blank'}
            type={type}
          />
        </span>
      </BaseCta>
    );
  }

  if (tag === 'button' || tag == 'span') {
    const { keepBorderOnHover, ...propsToPassOn } = props;
    return (
      <BaseCta {...propsToPassOn} className={ctaClass}>
        <span className={styles.label}>
          <Text field={label} /> <ActionIcon className={styles.icon} aria-hidden />
        </span>
      </BaseCta>
    );
  }

  return null;
};

export default PillCTA;
